import { css } from "@emotion/react";
import styled from "@emotion/styled";
import type { User } from "@rowan/prisma";
import { pxToRem } from "../../../design/utils";
import { fontMap, type PageColourOptions } from "./defaults";

export const PageWithSettingsStyled = styled.div<{
  settings?: User["ereaderSettings"];
  options?: PageColourOptions;
}>`
  position: relative;
  z-index: 0;
  ${({ settings }) => {
    const fontSizePx = settings?.fontSize ?? 16;
    const fontKey = settings?.font as keyof typeof fontMap;
    const font = fontMap[fontKey];

    const paragraphSpacingMultiplier = font?.paragraphSpacingMultiplier ?? 2;

    const paragraphSpacing = pxToRem(fontSizePx * paragraphSpacingMultiplier);

    return css`
      font-size: ${pxToRem(fontSizePx)};
      font-family: ${font?.fontFamily || "inherit"};
      line-height: ${font?.lineHeightMultiplier ?? 1.5};

      p {
        padding-top: ${paragraphSpacing};
      }
      .footnote-content {
        font-size: ${pxToRem(fontSizePx)};
      }
    `;
  }}

  ${({ options }) =>
    options &&
    `
      background-color: ${options.background};
      color: ${options.text};

      a {
        color: ${options.link_text};
      }
    `}
`;

export const PageWithSettings = ({
  children,
  settings,
  options,
  id,
  containerRef,
}: {
  children: React.ReactNode;
  id: string;
  containerRef: React.RefObject<HTMLDivElement | null>;
  settings?: User["ereaderSettings"];
  options?: PageColourOptions;
}) => {
  return (
    <PageWithSettingsStyled
      id={id}
      ref={containerRef}
      settings={settings}
      options={options}
    >
      {children}
    </PageWithSettingsStyled>
  );
};
